import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { ReactComponent as Camera } from './assets/CameraHeader.svg';
import { ReactComponent as Mic } from './assets/MicHeader.svg';
import { ReactComponent as Photo } from './assets/PhotoHeader.svg';
import { ReactComponent as Thanks } from './assets/ThanksHeader.svg';
import { ReactComponent as Upload } from './assets/UploadHeader.svg';
import style from './style.module.css';


const icons = {
  CAMERA: Camera,
  PHOTO: Photo,
  MIC: Mic,
  VIDEO: Camera,
  PICTURE: Photo,
  AUDIO: Mic,
  UPLOAD: Upload,
  THANKS: Thanks,
};

const Header = ({ icon = '', title = '', subtitle = '' }) => {
  const Icon = icons[icon];
  return (
    <header className={style.root}>
      <div className={style.middlePart}>
        {Icon && <Icon className={style.headerIcon} />}
        <h1>{title}</h1>
        <span className={style.subtitle}>{subtitle}</span>
      </div>
    </header>
  );
};

Header.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(Header);
